import { render } from "./ConfigureIMAP.vue?vue&type=template&id=251eb679"
import script from "./ConfigureIMAP.vue?vue&type=script&lang=js"
export * from "./ConfigureIMAP.vue?vue&type=script&lang=js"

import "./ConfigureIMAP.vue?vue&type=style&index=0&id=251eb679&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__